// extracted by mini-css-extract-plugin
export default {"tip-wrapper":"Tip_tip-wrapper__BZMgj"};